import React from 'react';
import PropTypes from 'prop-types';

import Header from './header';
import Workflow from './workflow';

import { Provider } from 'react-redux';
import { prepareWorkflow } from './store/workflow/reducer';
import configureStore from './store/configure';

import './styles.scss';

class TaskWorkflowEditor extends React.Component {
  static propTypes = {
    assigneeLabel: PropTypes.string,
    description: PropTypes.string,
    header: PropTypes.string,
    users: PropTypes.array.isRequired,
    workflow: PropTypes.object.isRequired
  }

  static defaultProps = {
    assigneeLabel: 'Assignee',
    header: 'Task Workflow'
  }

  store = configureStore({
    static: {
      assigneeLabel: this.props.assigneeLabel,
      description: this.props.description,
      header: this.props.header,
      roles: this.props.workflow.roles,
      users: this.props.users
    },
    workflow: prepareWorkflow(this.props.workflow)
  });

  render() {
    return (
      <Provider store={this.store}>
        <div className="task-workflow-editor">
          <Header />
          <Workflow />
        </div>
      </Provider>
    );
  }
}

export default TaskWorkflowEditor;
